module.exports = __webpack_public_path__ + "img/logo-natapp-testsystem.42bf7f91.svg";